import React, { Fragment, useState } from 'react';
import Popover from 'material-ui/Popover';

import PropTypes from 'prop-types';
import Icon from '../../Icon';

import styles from './styles.module.styl';

const Hint = ({ hintText, size = 12 }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleOpen = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <Fragment>
      <Icon
        name="icon-info"
        size={size}
        className={styles.infoIcon}
        onClick={handleOpen}
      />

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        disableRestoreFocus
      >
        <div className={styles.hintText}>{hintText}</div>
      </Popover>
    </Fragment>
  );
};

Hint.propTypes = {
  hintText: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default Hint;



// WEBPACK FOOTER //
// ./src/components/common/Hint/index.jsx